import React from 'react';
import { motion } from 'framer-motion';
import {
  SiReact,
  SiNodedotjs,
  SiMongodb,
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiBootstrap,
  SiTailwindcss,
  SiRedux,
  SiChartdotjs,
  SiJquery
} from 'react-icons/si';
import { FaLock, FaMapMarkerAlt } from 'react-icons/fa';

const techIcons = {
  'React.js': <SiReact className="text-cyan-400 text-xl" />,
  'Tailwind': <SiTailwindcss className="text-teal-300 text-xl" />,
  'Redux': <SiRedux className="text-purple-400 text-xl" />,
  'MongoDB': <SiMongodb className="text-green-400 text-xl" />,
  'MERN Stack': <SiReact className="text-cyan-400 text-xl" />,
  'JWT': <FaLock className="text-red-400 text-xl" />,
  'Geolocation': <FaMapMarkerAlt className="text-green-400 text-xl" />,
  'HTML5': <SiHtml5 className="text-orange-500 text-xl" />,
  'CSS3': <SiCss3 className="text-blue-500 text-xl" />,
  'JavaScript': <SiJavascript className="text-yellow-300 text-xl" />,
  'Chart.js': <SiChartdotjs className="text-pink-300 text-xl" />,
  'Node.js': <SiNodedotjs className="text-green-500 text-xl" />,
  'Bootstrap': <SiBootstrap className="text-purple-500 text-xl" />,
  'jQuery': <SiJquery className="text-blue-400 text-xl" />
};

const projects = [
  {
    title: 'Urban Monkey',
    description: 'E-commerce site for caps using MERN stack',
    tech: ['React.js', 'Tailwind', 'Redux', 'MongoDB'],
    period: 'Jan 2025 - April 2025',
    link: '#'
  },
  {
    title: 'Glide Ride',
    description: 'Ride-sharing app with real-time tracking',
    tech: ['MERN Stack', 'JWT', 'Geolocation'],
    period: 'April 2023 - Nov 2023',
    link: '#'
  },
  {
    title: 'Expense Tracker',
    description: 'Responsive expense management system',
    tech: ['HTML5', 'CSS3', 'JavaScript', 'Chart.js'],
    period: 'Dec 2022 - Feb 2023',
    link: '#'
  },
  {
    title: 'Time Tracker App',
    description: 'Time tracking app using React & Node.js',
    tech: ['React.js', 'Node.js', 'MongoDB', 'HTML5', 'CSS3', 'Bootstrap'],
    period: 'Sep 2022 - Nov 2023',
    link: '#'
  },
  {
    title: 'Meme Generator',
    description: 'Fun web app to generate custom memes',
    tech: ['HTML5', 'CSS3', 'JavaScript'],
    period: 'Jul 2022 - Aug 2022',
    link: '#'
  },
  {
    title: 'To-Do List App',
    description: 'Task management app with add/delete functionality',
    tech: ['HTML5', 'CSS3', 'Bootstrap', 'jQuery', 'JavaScript'],
    period: 'May 2022 - Jun 2022',
    link: '#'
  }
];

const Projects = () => {
  return (
    <section id="projects" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          Featured Projects
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="bg-gradient-to-br from-gray-700 to-gray-600 p-6 rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              <h3 className="text-xl font-semibold text-blue-400 mb-2">{project.title}</h3>
              <p className="text-gray-200 mb-4">{project.description}</p>
              <div className="flex flex-wrap gap-3 mb-4">
                {project.tech.map((tech) => (
                  <div
                    key={tech}
                    className="flex items-center gap-1 bg-gray-800 px-2 py-1 rounded text-sm text-white shadow"
                  >
                    {techIcons[tech] || null}
                    <span>{tech}</span>
                  </div>
                ))}
              </div>
              <p className="text-gray-400 mb-4">{project.period}</p>
              <a href={project.link} className="text-blue-400 hover:underline">View Project</a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
